import { LOCATION_CHANGE, push } from 'connected-react-router';
import {
    acceptChallengeNewPasswordRequired,
    CHALLENGE_NEW_PASSWORD_REQUIRED_ACCEPTED,
    CHALLENGE_NEW_PASSWORD_REQUIRED_ISSUED,
    CHALLENGE_NEW_PASSWORD_REQUIRED_REJECTED,
    CHALLENGE_NEW_PASSWORD_REQUIRED_SUBMITTED,
    rejectChallengeNewPasswordRequired,
} from './challenge-new-password-required-state';
import * as AuthService from '../auth-service';
import {
    getUser,
    isSignInFromSignUp,
    rejectSignIn,
    setUser,
} from '../sign-in/sign-in.state';
import { createMiddleware } from '../../../shared/redux';
import { match } from '../../../shared/utils/match';
import { ROUTES } from '../auth.constants';
import { validateChallengeNewPasswordRequired } from './challenge-new-password-required.validation';
import { redirectToSplashScreen } from '../splash-screen/splash-screen-state';

export const challengeNewPasswordRequiredMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [ROUTES.CHALLENGE_NEW_PASSWORD_REQUIRED]: state => (getUser(state) ? null : push('/auth/sign-in')),
    }),
    [CHALLENGE_NEW_PASSWORD_REQUIRED_ISSUED]: () => push(ROUTES.CHALLENGE_NEW_PASSWORD_REQUIRED),
    [CHALLENGE_NEW_PASSWORD_REQUIRED_SUBMITTED]: async (state, action) => (
        validateChallengeNewPasswordRequired(action.payload)
            .then(() => AuthService.completeNewPassword({
                user: getUser(state),
                password: action.payload.password,
                attributes: {
                    name: action.payload.attributes.name,
                    phone_number: action.payload.attributes.phone,
                },
            }))
            .then(user => acceptChallengeNewPasswordRequired({ user }))
            .catch(error => rejectChallengeNewPasswordRequired({ code: error.code || 'UnknownException', error }))
    ),
    [CHALLENGE_NEW_PASSWORD_REQUIRED_ACCEPTED]: (state, action) => ([
        setUser({ user: action.payload.user }),
        redirectToSplashScreen(),
    ]),
    [CHALLENGE_NEW_PASSWORD_REQUIRED_REJECTED]: (state, action) => (
        rejectSignIn({
            code: action.payload.code,
            error: action.payload.error,
            fromSignUp: isSignInFromSignUp(state),
        })
    ),
});
